var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailIlustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 480 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M396.735 120.685C377.682 110.253 357.833 106.065 336.171 108.747C309.49 112.041 288.416 115.922 262.886 105.979C241.42 97.6283 221.816 85.163 201.343 74.8283C159.465 53.5834 117.894 47.0079 86.498 88.91C69.7959 111.208 57.1102 136.812 48.3551 163.824C34.2 207.404 22.5673 255.661 28.9469 301.175C37.0163 358.873 86.498 385.959 145.69 365.057C169.629 356.608 192.735 344.24 218.265 340.702C271.69 333.281 315.722 382.334 379.788 370.408C490.212 349.885 482.057 167.4 396.735 120.685Z",
    fill: "url(#paint0_linear_579_82884)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M396.735 120.685C377.682 110.253 357.833 106.065 336.171 108.747C309.49 112.041 288.416 115.922 262.886 105.979C241.42 97.6283 221.816 85.163 201.343 74.8283C159.465 53.5834 117.894 47.0079 86.498 88.91C69.7959 111.208 57.1102 136.812 48.3551 163.824C34.2 207.404 22.5673 255.661 28.9469 301.175C37.0163 358.873 86.498 385.959 145.69 365.057C169.629 356.608 192.735 344.24 218.265 340.702C271.69 333.281 315.722 382.334 379.788 370.408C490.212 349.885 482.057 167.4 396.735 120.685Z",
    fill: "#1D1D1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M413.449 73.6774C405.673 69.4284 402.147 72.9672 399.318 69.4284C396.49 65.8897 407.094 56.706 385.849 47.5223C385.849 47.5223 384.441 27.7346 355.457 27.0244C326.473 26.3142 334.286 46.8121 326.51 51.759C318.735 56.706 316.616 48.9795 308.841 53.8774C301.065 58.7754 304.604 68.7182 298.249 70.1264C291.894 71.5345 283.396 63.7713 275.62 68.7182C267.845 73.6652 267.845 77.9019 264.318 77.9019C260.792 77.9019 253.714 75.0733 249.478 77.9019C245.241 80.7305 240.282 84.2692 240.282 84.2692H419.057C419.057 84.2692 421.224 77.9141 413.449 73.6774Z",
    stroke: "url(#paint1_linear_579_82884)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M210.71 232.53C205.249 229.555 202.763 232.028 200.78 229.555C198.796 227.081 206.241 220.616 191.351 214.163C191.351 214.163 190.359 200.265 169.996 199.763C149.633 199.261 155.106 213.661 149.645 217.138C144.184 220.616 142.702 215.155 137.241 218.632C131.78 222.11 134.253 229.053 129.796 230.044C125.339 231.036 119.363 225.575 113.878 229.053C108.392 232.53 108.416 235.506 105.943 235.506C103.469 235.506 98.4857 233.522 95.5102 235.506C92.5347 237.489 89.0571 239.975 89.0571 239.975H214.678C214.678 239.975 216.171 235.506 210.71 232.53Z",
    stroke: "url(#paint2_linear_579_82884)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M365.963 439.433H443.351C441.869 429.967 435.783 431.633 434.975 416.963C434.571 409.616 441.416 400.433 440.816 390.735C440.326 382.739 432.453 374.547 431.841 365.4C431.29 357.147 437.963 347.988 437.363 339.098C436.738 330.698 428.792 322.629 428.045 313.886C427.359 305.314 433.947 296.118 433.163 287.498C432.379 278.878 424.261 270.955 423.367 262.457C422.473 253.727 428.853 244.322 427.873 235.971C426.845 227.094 418.469 219.429 417.33 211.249C416.106 202.151 421.996 192.429 420.612 184.567C418.91 174.943 409.947 167.976 408.061 160.874C404.547 147.637 404.987 134.89 400.836 134.057C396.416 133.176 395.4 145.678 392.045 159.649C390.355 166.665 381.6 173.78 380.155 183.416C378.992 191.216 385.187 200.706 384.171 209.767C383.265 217.886 375.098 225.686 374.302 234.514C373.555 242.816 380.179 251.963 379.53 260.645C378.894 269.082 370.959 277.127 370.432 285.698C369.906 294.269 376.714 303.233 376.249 311.694C375.771 320.363 367.996 328.555 367.592 336.894C367.175 345.722 374.143 354.624 373.8 362.804C373.42 371.878 365.755 380.18 365.473 388.114C365.13 397.739 372.196 406.616 371.975 413.951C371.51 429.869 364.224 426.551 363.967 439.359L365.963 439.433Z",
    fill: "url(#paint3_linear_579_82884)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M399.184 159.49V435.857",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M411.269 188.461L398.669 199.347L388.359 185.596",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M411.269 236.571L398.669 247.445L388.359 233.706",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M411.269 281.804L398.669 292.69L388.359 278.939",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M411.269 335.645L398.669 346.519L388.359 332.78",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M411.269 390.049L398.669 400.922L388.359 387.184",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M313.249 439.432H372.992C371.841 432.085 367.151 433.408 366.526 422.094C366.208 416.388 371.486 409.335 371.032 401.841C370.653 395.718 364.579 389.339 364.102 382.249C363.673 375.881 368.865 368.779 368.363 361.947C367.886 355.457 361.726 349.237 361.175 342.49C360.624 335.743 365.73 328.763 365.13 322.114C364.53 315.465 358.249 309.343 357.588 302.792C356.902 296.045 361.824 288.796 361.065 282.33C360.269 275.486 353.804 269.571 352.935 263.265C351.955 256.237 356.535 248.73 355.457 242.669C354.147 235.237 347.228 229.849 345.784 224.375C343.065 214.163 343.408 204.306 340.2 203.669C336.783 202.984 336 212.632 333.416 223.432C332.118 228.845 325.347 234.343 324.232 241.8C323.339 247.824 328.114 255.147 327.33 262.139C326.632 268.408 320.339 274.383 319.714 281.241C319.139 287.645 324.257 294.71 323.755 301.408C323.265 307.922 317.155 314.13 316.726 320.743C316.298 327.355 321.624 334.286 321.22 340.812C320.816 347.339 314.853 353.828 314.547 360.269C314.216 367.077 319.592 373.947 319.335 380.265C319.041 387.269 313.126 393.734 312.906 399.857C312.637 407.277 318.098 414.147 317.926 419.792C317.559 432.036 311.939 429.526 311.743 439.383L313.249 439.432Z",
    fill: "url(#paint4_linear_579_82884)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M338.902 223.347V436.678",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M348.22 245.706L338.498 254.106L330.539 243.49",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M348.22 282.833L338.498 291.233L330.539 280.628",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M348.22 317.755L338.498 326.155L330.539 315.551",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M348.22 359.314L338.498 367.714L330.539 357.098",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M348.22 401.314L338.498 409.702L330.539 399.098",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M259.996 438.857V191.29H273.061V438.857",
    fill: "#1D1D1D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M259.996 438.857V191.29H273.061V438.857",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M253.469 438.857V191.29H266.535V438.857",
    fill: "#DBC958"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M253.469 438.857V191.29H266.535V438.857",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M266.535 191.29H253.469V220.677H266.535V191.29Z",
    fill: "#1D1D1D"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M309.221 94.6406H212.413L254.608 198.281H351.429V136.837C351.429 131.294 350.337 125.806 348.216 120.686C346.094 115.566 342.985 110.914 339.066 106.995C335.146 103.077 330.493 99.9689 325.372 97.8491C320.251 95.7293 314.763 94.639 309.221 94.6406Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M247.224 180.135L254.571 198.282H351.428V136.837C351.428 135.906 351.428 134.975 351.331 134.057H247.249L247.224 180.135Z",
    fill: "#1D1D1D"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M308.51 134.057H298.322",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M351.331 134.057H320.498",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M212.412 94.6406C223.607 94.6406 234.342 99.0876 242.258 107.003C250.173 114.919 254.62 125.654 254.62 136.849V198.294H170.204V136.837C170.207 125.644 174.656 114.912 182.571 106.999C190.486 99.0859 201.22 94.6406 212.412 94.6406Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M254.608 191.29H181.873V198.281H254.608V191.29Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M254.608 191.29H104.082V198.281H254.608V191.29Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M254.608 191.29H181.873V198.281H254.608V191.29Z",
    fill: "#1D1D1D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M315.514 69.6611H285.306V90.8815H315.514V69.6611Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M287.755 69.6611H281.229V135.784H287.755V69.6611Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M284.486 144.759C288.543 144.759 291.833 141.469 291.833 137.412C291.833 133.354 288.543 130.065 284.486 130.065C280.428 130.065 277.139 133.354 277.139 137.412C277.139 141.469 280.428 144.759 284.486 144.759Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M176.743 111.612C193.788 120.269 223.42 134.143 250.751 141.123",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M162.441 104.082C162.441 104.082 167.902 107.168 176.743 111.662",
    stroke: "url(#paint5_linear_579_82884)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M156.306 103.629L168.564 74.5104L79.6779 52.8247L156.306 103.629Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 1.2629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M162.282 78.0369L156.306 103.629L79.6779 52.8247L162.282 78.0369Z",
    fill: "#59D9C6",
    stroke: "#1D1D1D",
    strokeWidth: 1.2629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M162.282 78.0369L148.335 89.988L79.6779 52.8247L162.282 78.0369Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 1.2629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M168.564 74.5104L180.98 69.4655L79.6779 52.8247L168.564 74.5104Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 1.2629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M139.041 99.0981L141.919 100.861",
    stroke: "url(#paint6_linear_579_82884)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M123.343 89.4736L132.98 95.3757",
    stroke: "url(#paint7_linear_579_82884)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M112.519 159.368V127.788L202.861 142.311L112.519 159.368Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 1.2629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M116.939 133.47L112.519 159.368L202.861 142.311L116.939 133.47Z",
    fill: "#59D9C6",
    stroke: "#1D1D1D",
    strokeWidth: 1.2629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M116.939 133.47L125.155 149.89L202.861 142.311L116.939 133.47Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 1.2629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M112.518 127.788L103.041 118.311L202.861 142.311L112.518 127.788Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 1.2629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M144.869 158.78L152.706 157.188",
    stroke: "url(#paint8_linear_579_82884)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M117.343 164.376L137.045 160.372",
    stroke: "url(#paint9_linear_579_82884)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M101.633 157.42C101.633 157.42 30.6124 169.665 17.143 233.339C3.6736 297.012 74.694 300.686 86.9389 270.073C99.1838 239.461 45.3062 227.216 33.0614 256.604C20.8165 285.992 57.5511 336.196 107.755 338.645C149.474 340.678 266.437 291.98 339.184 279.673C339.184 279.673 393.061 264.759 476.327 268.029",
    stroke: "url(#paint10_linear_579_82884)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M452.241 357.012H472.653",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M452.241 387.208H472.653",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M22.445 386.4H449.792V357.82H22.445",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M22.445 386.4H449.792V357.82H22.445",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1508 439.053V295.273C52.1511 294.92 52.2228 294.572 52.3617 294.247C52.5006 293.923 52.7038 293.631 52.959 293.387L64.1263 282.869C64.6292 282.399 65.2976 282.147 65.9858 282.167C66.6739 282.188 67.326 282.48 67.7998 282.979L77.5957 293.4C78.0401 293.885 78.2888 294.517 78.2937 295.175V439.053",
    fill: "#215AAE"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1508 439.053V295.273C52.1511 294.92 52.2228 294.572 52.3617 294.247C52.5006 293.923 52.7038 293.631 52.959 293.387L64.1263 282.869C64.6292 282.399 65.2976 282.147 65.9858 282.167C66.6739 282.188 67.326 282.48 67.7998 282.979L77.5957 293.4C78.0401 293.885 78.2888 294.517 78.2937 295.175V439.053",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9796 440.277V295.273C48.9793 294.919 49.0519 294.569 49.1931 294.245C49.3343 293.92 49.5409 293.628 49.8 293.388L60.9674 282.869C61.2156 282.635 61.5077 282.452 61.8268 282.331C62.1459 282.209 62.4857 282.152 62.827 282.162C63.1682 282.173 63.504 282.25 63.8153 282.39C64.1265 282.53 64.4071 282.731 64.6408 282.979L74.4368 293.4C74.8863 293.882 75.1359 294.516 75.1347 295.175V440.277",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9796 440.277V295.273C48.9793 294.919 49.0519 294.569 49.1931 294.245C49.3343 293.92 49.5409 293.628 49.8 293.388L60.9674 282.869C61.2156 282.635 61.5077 282.452 61.8268 282.331C62.1459 282.209 62.4857 282.152 62.827 282.162C63.1682 282.173 63.504 282.25 63.8153 282.39C64.1265 282.53 64.4071 282.731 64.6408 282.979L74.4368 293.4C74.8863 293.882 75.1359 294.516 75.1347 295.175V440.277",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M146.315 439.053V295.273C146.315 294.921 146.387 294.572 146.525 294.248C146.664 293.923 146.868 293.631 147.123 293.388L158.302 282.869C158.551 282.635 158.843 282.452 159.162 282.331C159.481 282.209 159.821 282.152 160.162 282.162C160.503 282.173 160.839 282.25 161.15 282.39C161.461 282.53 161.742 282.731 161.976 282.979L171.772 293.4C172.221 293.882 172.471 294.516 172.47 295.175V439.053",
    fill: "#215AAE"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M146.315 439.053V295.273C146.315 294.921 146.387 294.572 146.525 294.248C146.664 293.923 146.868 293.631 147.123 293.388L158.302 282.869C158.551 282.635 158.843 282.452 159.162 282.331C159.481 282.209 159.821 282.152 160.162 282.162C160.503 282.173 160.839 282.25 161.15 282.39C161.461 282.53 161.742 282.731 161.976 282.979L171.772 293.4C172.221 293.882 172.471 294.516 172.47 295.175V439.053",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M143.669 440.277V295.273C143.669 294.919 143.742 294.569 143.883 294.245C144.024 293.92 144.231 293.628 144.49 293.387L155.657 282.869C156.16 282.399 156.829 282.147 157.517 282.167C158.205 282.188 158.857 282.48 159.331 282.979L169.127 293.4C169.58 293.88 169.833 294.515 169.837 295.175V440.277",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M143.669 440.277V295.273C143.669 294.919 143.742 294.569 143.883 294.245C144.024 293.92 144.231 293.628 144.49 293.387L155.657 282.869C156.16 282.399 156.829 282.147 157.517 282.167C158.205 282.188 158.857 282.48 159.331 282.979L169.127 293.4C169.58 293.88 169.833 294.515 169.837 295.175V440.277",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M241.004 439.053V295.273C241.004 294.919 241.077 294.569 241.218 294.245C241.359 293.92 241.566 293.628 241.825 293.387L252.992 282.869C253.495 282.399 254.164 282.147 254.852 282.167C255.54 282.188 256.192 282.48 256.666 282.979L266.462 293.4C266.915 293.88 267.168 294.515 267.172 295.175V440.277",
    fill: "#215AAE"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M241.004 439.053V295.273C241.004 294.919 241.077 294.569 241.218 294.245C241.359 293.92 241.566 293.628 241.825 293.387L252.992 282.869C253.495 282.399 254.164 282.147 254.852 282.167C255.54 282.188 256.192 282.48 256.666 282.979L266.462 293.4C266.915 293.88 267.168 294.515 267.172 295.175V440.277",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M238.371 440.277V295.273C238.372 294.921 238.443 294.572 238.582 294.248C238.721 293.923 238.924 293.631 239.18 293.388L250.359 282.869C250.607 282.635 250.899 282.452 251.218 282.331C251.538 282.209 251.877 282.152 252.219 282.162C252.56 282.173 252.896 282.25 253.207 282.39C253.518 282.53 253.799 282.731 254.033 282.979L263.828 293.4C264.278 293.882 264.528 294.516 264.526 295.175V440.277",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M238.371 440.277V295.273C238.372 294.921 238.443 294.572 238.582 294.248C238.721 293.923 238.924 293.631 239.18 293.388L250.359 282.869C250.607 282.635 250.899 282.452 251.218 282.331C251.538 282.209 251.877 282.152 252.219 282.162C252.56 282.173 252.896 282.25 253.207 282.39C253.518 282.53 253.799 282.731 254.033 282.979L263.828 293.4C264.278 293.882 264.528 294.516 264.526 295.175V440.277",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M335.706 439.053V295.273C335.707 294.92 335.778 294.572 335.917 294.247C336.056 293.923 336.259 293.631 336.514 293.387L347.682 282.869C348.185 282.399 348.853 282.147 349.541 282.167C350.229 282.188 350.881 282.48 351.355 282.979L361.151 293.4C361.596 293.885 361.844 294.517 361.849 295.175V439.053",
    fill: "#215AAE"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M335.706 439.053V295.273C335.707 294.92 335.778 294.572 335.917 294.247C336.056 293.923 336.259 293.631 336.514 293.387L347.682 282.869C348.185 282.399 348.853 282.147 349.541 282.167C350.229 282.188 350.881 282.48 351.355 282.979L361.151 293.4C361.596 293.885 361.844 294.517 361.849 295.175V439.053",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M333.061 440.277V295.273C333.061 294.919 333.134 294.569 333.275 294.245C333.416 293.92 333.623 293.628 333.882 293.388L345.049 282.869C345.297 282.635 345.589 282.452 345.908 282.331C346.227 282.209 346.567 282.152 346.909 282.162C347.25 282.173 347.586 282.25 347.897 282.39C348.208 282.53 348.489 282.731 348.722 282.979L358.518 293.4C358.968 293.882 359.217 294.516 359.216 295.175V440.277",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M333.061 440.277V295.273C333.061 294.919 333.134 294.569 333.275 294.245C333.416 293.92 333.623 293.628 333.882 293.388L345.049 282.869C345.297 282.635 345.589 282.452 345.908 282.331C346.227 282.209 346.567 282.152 346.909 282.162C347.25 282.173 347.586 282.25 347.897 282.39C348.208 282.53 348.489 282.731 348.722 282.979L358.518 293.4C358.968 293.882 359.217 294.516 359.216 295.175V440.277",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M430.396 439.053V295.273C430.396 294.921 430.468 294.572 430.607 294.248C430.746 293.923 430.949 293.631 431.204 293.388L442.384 282.869C442.632 282.635 442.924 282.452 443.243 282.331C443.562 282.209 443.902 282.152 444.244 282.162C444.585 282.173 444.921 282.25 445.232 282.39C445.543 282.53 445.824 282.731 446.057 282.979L455.853 293.4C456.303 293.882 456.552 294.516 456.551 295.175V439.053",
    fill: "#215AAE"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M430.396 439.053V295.273C430.396 294.921 430.468 294.572 430.607 294.248C430.746 293.923 430.949 293.631 431.204 293.388L442.384 282.869C442.632 282.635 442.924 282.452 443.243 282.331C443.562 282.209 443.902 282.152 444.244 282.162C444.585 282.173 444.921 282.25 445.232 282.39C445.543 282.53 445.824 282.731 446.057 282.979L455.853 293.4C456.303 293.882 456.552 294.516 456.551 295.175V439.053",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M427.751 440.277V295.273C427.751 294.919 427.823 294.569 427.965 294.245C428.106 293.92 428.312 293.628 428.572 293.387L439.739 282.869C440.242 282.399 440.91 282.147 441.598 282.167C442.286 282.188 442.939 282.48 443.412 282.979L453.208 293.4C453.661 293.88 453.915 294.515 453.918 295.175V440.277",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M427.751 440.277V295.273C427.751 294.919 427.823 294.569 427.965 294.245C428.106 293.92 428.312 293.628 428.572 293.387L439.739 282.869C440.242 282.399 440.91 282.147 441.598 282.167C442.286 282.188 442.939 282.48 443.412 282.979L453.208 293.4C453.661 293.88 453.915 294.515 453.918 295.175V440.277",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6289 282.979V293.461",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8286 288.392V313.2",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M148.825 290.424V321.808",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M152.878 286.371V300.036",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M250.359 282.869V313.714",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M256.175 285.355V330.93",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M337.69 290.424V324.845",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M350.853 286.371V294.979",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M436.421 285.857V304.09",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M447.564 287.89V340.543",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M427.31 364.849H416.167",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M427.31 373.457H388.322",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M281.988 373.457H264.27",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M188.829 373.457H171.11",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5758 368.902H30.8574",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5754 376.996H41.4856",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M272.878 368.902H264.27",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M178.702 378.514H170.094",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M142.751 378.514H134.143",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M461.73 373.457H454.139",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M471.857 373.457H467.302",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6938 320.816C74.6938 320.816 71.6326 347.13 67.9591 374.057C64.2856 400.983 71.0203 428.534 72.8571 430.983",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5835 374.081C63.1712 368.828 63.661 365.51 63.661 365.51",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6207 427.922C71.6207 427.922 60.6003 425.473 60.6003 405.882C60.6003 397.837 61.1146 389.596 61.7268 382.616",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M164.082 289.592C164.082 289.592 166.531 291.429 162.245 312.245C157.959 333.061 158.571 363.673 164.082 380.816",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M170.204 328.163C170.204 328.163 164.082 346.53 168.368 372.245",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M240 339.783C240 339.783 243.061 357.538 246.122 375.893C249.184 394.249 246.735 419.975 244.286 426.697C241.837 433.42 239.388 438.942 239.388 438.942",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M251.535 429.942C248.804 438.318 245.412 428.534 245.412 428.534",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M251.425 367.347C251.425 367.347 257.192 397.114 253.935 419.522",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M238.776 377.143C238.776 377.143 244.898 390 239.388 402.245",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M353.02 378.955C353.84 382.698 354.916 386.38 356.241 389.975",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M358.078 315.306C354.192 327.638 351.727 340.373 350.731 353.265C350.365 359.787 350.73 366.33 351.82 372.771",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M346.445 371.608C346.445 371.608 351.955 392.424 355.017 399.771C358.078 407.118 356.853 424.861 353.18 433.432",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M429.074 324.49C429.074 324.49 441.319 346.531 429.686 382.641",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M440.327 362.13C440.4 369.012 439.788 377.73 437.033 385.077C431.523 399.771 429.074 404.669 429.074 404.669",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M439.482 350.204C439.482 350.204 439.886 352.837 440.131 356.89",
    stroke: "#215AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_579_82884",
    x1: 27.1546,
    y1: 58.1045,
    x2: 325.506,
    y2: 470.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_579_82884",
    x1: 240.282,
    y1: 27.0063,
    x2: 273.51,
    y2: 130.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_579_82884",
    x1: 89.0571,
    y1: 199.75,
    x2: 112.394,
    y2: 272.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_579_82884",
    x1: 363.967,
    y1: 134.013,
    x2: 512.687,
    y2: 172.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_579_82884",
    x1: 311.743,
    y1: 203.635,
    x2: 426.498,
    y2: 233.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_579_82884",
    x1: 162.441,
    y1: 104.082,
    x2: 168.713,
    y2: 115.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_579_82884",
    x1: 139.041,
    y1: 99.0981,
    x2: 140.612,
    y2: 101.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_579_82884",
    x1: 123.343,
    y1: 89.4736,
    x2: 128.6,
    y2: 98.0578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_579_82884",
    x1: 144.869,
    y1: 157.188,
    x2: 145.491,
    y2: 160.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_579_82884",
    x1: 117.343,
    y1: 160.372,
    x2: 118.906,
    y2: 168.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_579_82884",
    x1: 15.4514,
    y1: 157.42,
    x2: 138.96,
    y2: 471.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIlustration);
export default __webpack_public_path__ + "static/media/email-ilustration.7dd911728a4f4b825ad4fdc416c3ab3b.svg";
export { ForwardRef as ReactComponent };